import Iconify from "@/src/components/iconify";
import { CustomButton } from "@/src/lib/ui";
import IconCode from "@/src/lib/iconCode";
import { useRouter } from "next/router";

const ConfirmAppointment = ({ paymentId, onClose }) => {
    const router = useRouter();
    return (
        <div className="max-w-6xl mx-auto">
            <div className="md:py-16 py-8 flex items-center justify-center flex-col w-full max-w-2xl mx-auto md:px-5 px-0">
                <Iconify
                    icon={IconCode.checkmark}
                    width={80}
                    className="text-primary mb-5"
                />
                <p className="md:text-2xl font-bold text-xl text-black text-center">
                    Thanks, your booking has been confirmed!
                </p>

                <p className="text-center text-sm text-black">
                    You can view your booking details in your account.
                </p>

                <div className="flex flex-row gap-2  md:mt-0 mt-2">
                    <p className="text-sm text-black">
                        Payment ID: <strong>{paymentId}</strong>
                    </p>
                </div>

                <div className="flex flex-row gap-2 md:mt-8 mt-4">
                    <CustomButton
                        className=" bg-primary text-white font-family-bold md:text-base text-sm md:leading-3 leading-none md:py-4 py-2.5 md:px-6 px-3 rounded-md"
                        onClick={() => router.push("/my-account/my-orders")}
                    >
                        View Orders
                    </CustomButton>

                    <CustomButton
                        variant="outlined"
                        color="default"
                        className="font-family-bold mt-0 text-base leading-3 md:py-4 py-2.5 md:px-6 px-3 rounded-md"
                        onClick={onClose}
                    >
                        Close
                    </CustomButton>
                </div>
            </div>
        </div>
    );
};

export default ConfirmAppointment;
